import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex mt-4 justify-end pa-3" }

import {
  PRODUCT_CATEGORIES_INFO,
  PRODUCT_CATEGORIES_REPORTS_UNITS,
  ProductCategory,
  ProductPlansService,
  ProductSupply,
} from '@prodcard/core'
import { ref, Ref } from 'vue'
import { Pagination } from '../../../components'
import { usePaginator } from '../../../mixins'
import { createCtx, handleError } from 'libs/apps-vue/src/helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSupplyListTab',
  props: {
    productPlansService: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



const { paginator, count, getPageCount, getPageFrom } = usePaginator('productSuppliesPaginator')
const isLoading = ref(false)
const productSupplies: Ref<ProductSupply[]> = ref([])

const update = () => {
  handleError(async () => {
    const from = getPageFrom.value
    const resp = await props.productPlansService.findAll(createCtx(), {
      paging: { from: from, count: paginator.value.per },
    })
    productSupplies.value = resp.items
    count.value = resp.total
  }, isLoading)
}

const headers = [
  { title: '№', key: 'number', sortable: false },
  { title: 'Дата', key: 'dataEntryDate', sortable: false },
  { title: 'Категория', key: 'category', sortable: false },
  { title: 'Количество', key: 'amount', sortable: false },
]

__expose({ update })

return (_ctx: any,_cache: any) => {
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!

  return (_openBlock(), _createBlock(_component_v_data_table_server, {
    headers: headers,
    items: productSupplies.value,
    loading: isLoading.value,
    "items-length": _unref(count),
    "no-data-text": "Нет данных",
    "hide-default-footer": "",
    hover: "",
    "onUpdate:options": update
  }, {
    "item.number": _withCtx(({ item }) => [
      _createElementVNode("p", null, _toDisplayString(_unref(getPageFrom) + item.index + 1), 1)
    ]),
    "item.dataEntryDate": _withCtx(({ item }) => [
      _createElementVNode("p", null, _toDisplayString(new Date(item.raw.dataEntryDate).toLocaleDateString()), 1)
    ]),
    "item.category": _withCtx(({ item }) => [
      _createElementVNode("p", null, _toDisplayString(`${_unref(PRODUCT_CATEGORIES_INFO)[item.raw.category as ProductCategory].description} ${
            _unref(PRODUCT_CATEGORIES_REPORTS_UNITS)[item.raw.category as ProductCategory] || ''
          }`), 1)
    ]),
    bottom: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, "Итого: " + _toDisplayString(_unref(count)), 1)
      ]),
      _createVNode(_unref(Pagination), {
        modelValue: _unref(paginator),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(paginator) ? (paginator).value = $event : null)),
          update
        ],
        "page-count": _unref(getPageCount),
        disabled: isLoading.value || _unref(getPageCount) === 0
      }, null, 8, ["modelValue", "page-count", "disabled"])
    ]),
    _: 1
  }, 8, ["items", "loading", "items-length"]))
}
}

})